import React from 'react';
import PropTypes from 'prop-types';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { FLAG_NAMES } from '@common/flagNames';
import { PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS } from '@common/constants';
import {
  withAdminFFs,
  useAdminFeatureFlag,
} from '@common/AdminLaunchDarklyProvider';
import CreateProjectModal from '../CreateProjectModal';
import ProjectAdminSettingsTabs, { tabsPropType } from './component';

const ProjectAdminSettingsTabsContainer = ({
  mainTab,
  additionalTabs,
  children,
  onProfileSave,
  onTabChange,
}) => {
  const projectId = useCurrentProjectId();
  const { value: showLocations, loading: isLocationsFFLoading } =
    useAdminFeatureFlag(FLAG_NAMES.ADMIN_FLAGS.SHOW_LOCATIONS);
  const { value: showNotifications, loading: isNotificationsFFLoading } =
    useAdminFeatureFlag(FLAG_NAMES.ADMIN_FLAGS.SHOW_NOTIFICATIONS);
  const areFFsLoading = isLocationsFFLoading || isNotificationsFFLoading;

  if (areFFsLoading) return <></>;

  return (
    <ProjectAdminSettingsTabs
      projectId={projectId}
      showLocations={showLocations || false}
      showNotifications={showNotifications || false}
      mainTab={mainTab}
      onProfileSave={onProfileSave}
      additionalTabs={additionalTabs}
      onTabChange={onTabChange}
    >
      {children}
    </ProjectAdminSettingsTabs>
  );
};

ProjectAdminSettingsTabsContainer.propTypes = {
  mainTab: PropTypes.string,
  additionalTabs: tabsPropType,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  onProfileSave: PropTypes.func,
  onTabChange: PropTypes.func,
};

const ProjectAdminSettingsTabsContainerWithFFs = withAdminFFs(
  ProjectAdminSettingsTabsContainer
);

ProjectAdminSettingsTabsContainerWithFFs.editProfileOpStatuses =
  CreateProjectModal.opStatuses;
ProjectAdminSettingsTabsContainerWithFFs.PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS =
  PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS;

export default ProjectAdminSettingsTabsContainerWithFFs;
